import React, { memo } from 'react';
import { Row } from '@dealstack/frontend/shared/components/Table/DefaultTable/Row.tsx';
import { Cell } from '@dealstack/frontend/shared/components/Table/DefaultTable/Cell.tsx';
import { StringInput } from '@dealstack/frontend/shared/components/forms/StringInput/StringInput.tsx';
import { Text } from '@mantine/core';
import { ButtonsRight } from '@dealstack/frontend/shared/components/fundament/Button/ButtonLayouts.tsx';
import {
	CloseButtonSquare,
	DeleteButtonSquare,
	SaveButtonSquare,
	ThreeDotMenuIconButton,
} from '@dealstack/frontend/shared/components/fundament/Button/CommonButtons.tsx';
import { RowWrapper } from '@dealstack/frontend/shared/components/DynamicResponsibleTable/RowWrapper.ts';
import { useCustomDetailDefinitionRowController } from './useCustomDetailDefinitionRowController.ts';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	onRemoveClicked: () => void;
	index: number;
}

const CustomDetailDefinitionRow = ({ onRemoveClicked, index }: Props) => {
	const tMipCreate = useTranslationMipCreate();

	const {
		isInvalid,
		isEdit,
		nameKey,
		nameValue,
		instructionKey,
		instructionValue,
		onSaveButtonClicked,
		onCloseButtonClicked,
		onEditButtonClicked,
	} = useCustomDetailDefinitionRowController(onRemoveClicked, index);

	return (
		<RowWrapper isInvalid={isInvalid}>
			<Row>
				<Cell>
					{isEdit ? (
						<StringInput
							name={nameKey}
							rhfOptions={{
								required: tMipCreate(
									'personal_data.tag_manager_modal.error_name_required'
								),
							}}
							maxSize
						/>
					) : (
						<Text variant="p-sm">{nameValue}</Text>
					)}
				</Cell>
				<Cell>
					{isEdit ? (
						<StringInput name={instructionKey} maxSize />
					) : (
						<Text>{instructionValue}</Text>
					)}
				</Cell>

				{isEdit ? (
					<ButtonsRight gap="sm">
						<SaveButtonSquare onClick={onSaveButtonClicked} />
						<CloseButtonSquare onClick={onCloseButtonClicked} />
						<DeleteButtonSquare onClick={onRemoveClicked} />
					</ButtonsRight>
				) : (
					<Cell align="right">
						<ThreeDotMenuIconButton onClick={onEditButtonClicked} />
					</Cell>
				)}
			</Row>
		</RowWrapper>
	);
};
const _CustomDetailDefinitionRowExport = memo(CustomDetailDefinitionRow);

export { _CustomDetailDefinitionRowExport as CustomDetailDefinitionRow };
